/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';
import { type SafeString } from 'handlebars';

interface IArgs {
  label: string;

  value?: string | number | SafeString | null;
}

interface UiProtectionDisputePanelRowSignature {
  Element: HTMLDivElement;

  Args: IArgs;

  Blocks: {
    default: [];
  };
}

const UiProtectionDisputePanelRowComponent =
  templateOnly<UiProtectionDisputePanelRowSignature>();

export default UiProtectionDisputePanelRowComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Protection::DisputePanel::Row': typeof UiProtectionDisputePanelRowComponent;
    'ui/protection/dispute-panel/row': typeof UiProtectionDisputePanelRowComponent;
  }
}
